import { RootState } from 'app/store/rootReducer';

export const getBonusPayout = (state: RootState) => state.bonusPayout;

export const getBonusPayoutPromotionAmount = (state: RootState) =>
  state.bonusPayout.promotionAmount;

export const getBonusPayoutPhoneNumber = (state: RootState) =>
  state.bonusPayout.phoneNumber;

export const getBonusExpiredDate = (state: RootState) =>
  state.bonusPayout.expiredDate;

export const getIsPathAnonymous = (state: RootState) =>
  state.bonusPayout.isPathAnonymous;

export const getBonusCase = (state: RootState) => state.bonusPayout.bonusCase;
